export interface IntrospectionResultData {
  __schema: {
    types: {
      kind: string;
      name: string;
      possibleTypes: {
        name: string;
      }[];
    }[];
  };
}

const result: IntrospectionResultData = {
  __schema: {
    types: [
      {
        kind: "INTERFACE",
        name: "Entity",
        possibleTypes: [
          {
            name: "User"
          },
          {
            name: "File"
          },
          {
            name: "PathAlias"
          },
          {
            name: "BlockContentBasic"
          },
          {
            name: "CommentComment"
          },
          {
            name: "ContactMessageFeedback"
          },
          {
            name: "ContactMessagePersonal"
          },
          {
            name: "MenuLinkContentMenuLinkContent"
          },
          {
            name: "NodeEvent"
          },
          {
            name: "NodeHeritageSite"
          },
          {
            name: "NodeUserSubmissionTwitter"
          },
          {
            name: "NodeUserSubmissionWebsite"
          },
          {
            name: "ParagraphAudio"
          },
          {
            name: "ParagraphCopy"
          },
          {
            name: "ParagraphHeroImage"
          },
          {
            name: "ParagraphHeroVideo"
          },
          {
            name: "ParagraphImage"
          },
          {
            name: "ParagraphVideo"
          },
          {
            name: "ShortcutDefault"
          },
          {
            name: "TaxonomyTermTags"
          },
          {
            name: "UnexposedEntity"
          }
        ]
      },
      {
        kind: "INTERFACE",
        name: "Url",
        possibleTypes: [
          {
            name: "DefaultInternalUrl"
          },
          {
            name: "EntityCanonicalUrl"
          },
          {
            name: "ExternalUrl"
          }
        ]
      },
      {
        kind: "INTERFACE",
        name: "Node",
        possibleTypes: [
          {
            name: "NodeEvent"
          },
          {
            name: "NodeHeritageSite"
          },
          {
            name: "NodeUserSubmissionTwitter"
          },
          {
            name: "NodeUserSubmissionWebsite"
          }
        ]
      },
      {
        kind: "INTERFACE",
        name: "EntityOwnable",
        possibleTypes: [
          {
            name: "File"
          },
          {
            name: "CommentComment"
          },
          {
            name: "NodeEvent"
          },
          {
            name: "NodeHeritageSite"
          },
          {
            name: "NodeUserSubmissionTwitter"
          },
          {
            name: "NodeUserSubmissionWebsite"
          },
          {
            name: "ParagraphAudio"
          },
          {
            name: "ParagraphCopy"
          },
          {
            name: "ParagraphHeroImage"
          },
          {
            name: "ParagraphHeroVideo"
          },
          {
            name: "ParagraphImage"
          },
          {
            name: "ParagraphVideo"
          }
        ]
      },
      {
        kind: "INTERFACE",
        name: "BlockContent",
        possibleTypes: [
          {
            name: "BlockContentBasic"
          }
        ]
      },
      {
        kind: "INTERFACE",
        name: "Comment",
        possibleTypes: [
          {
            name: "CommentComment"
          }
        ]
      },
      {
        kind: "INTERFACE",
        name: "ContactMessage",
        possibleTypes: [
          {
            name: "ContactMessageFeedback"
          },
          {
            name: "ContactMessagePersonal"
          }
        ]
      },
      {
        kind: "INTERFACE",
        name: "EntityPublishable",
        possibleTypes: [
          {
            name: "PathAlias"
          },
          {
            name: "BlockContentBasic"
          },
          {
            name: "CommentComment"
          },
          {
            name: "MenuLinkContentMenuLinkContent"
          },
          {
            name: "NodeEvent"
          },
          {
            name: "NodeHeritageSite"
          },
          {
            name: "NodeUserSubmissionTwitter"
          },
          {
            name: "NodeUserSubmissionWebsite"
          },
          {
            name: "ParagraphAudio"
          },
          {
            name: "ParagraphCopy"
          },
          {
            name: "ParagraphHeroImage"
          },
          {
            name: "ParagraphHeroVideo"
          },
          {
            name: "ParagraphImage"
          },
          {
            name: "ParagraphVideo"
          },
          {
            name: "TaxonomyTermTags"
          }
        ]
      },
      {
        kind: "INTERFACE",
        name: "EntityRevisionable",
        possibleTypes: [
          {
            name: "PathAlias"
          },
          {
            name: "BlockContentBasic"
          },
          {
            name: "MenuLinkContentMenuLinkContent"
          },
          {
            name: "NodeEvent"
          },
          {
            name: "NodeHeritageSite"
          },
          {
            name: "NodeUserSubmissionTwitter"
          },
          {
            name: "NodeUserSubmissionWebsite"
          },
          {
            name: "ParagraphAudio"
          },
          {
            name: "ParagraphCopy"
          },
          {
            name: "ParagraphHeroImage"
          },
          {
            name: "ParagraphHeroVideo"
          },
          {
            name: "ParagraphImage"
          },
          {
            name: "ParagraphVideo"
          },
          {
            name: "TaxonomyTermTags"
          }
        ]
      },
      {
        kind: "INTERFACE",
        name: "Shortcut",
        possibleTypes: [
          {
            name: "ShortcutDefault"
          }
        ]
      },
      {
        kind: "INTERFACE",
        name: "TaxonomyTerm",
        possibleTypes: [
          {
            name: "TaxonomyTermTags"
          }
        ]
      },
      {
        kind: "INTERFACE",
        name: "MenuLinkContent",
        possibleTypes: [
          {
            name: "MenuLinkContentMenuLinkContent"
          }
        ]
      },
      {
        kind: "INTERFACE",
        name: "Paragraph",
        possibleTypes: [
          {
            name: "ParagraphAudio"
          },
          {
            name: "ParagraphCopy"
          },
          {
            name: "ParagraphHeroImage"
          },
          {
            name: "ParagraphHeroVideo"
          },
          {
            name: "ParagraphImage"
          },
          {
            name: "ParagraphVideo"
          }
        ]
      },
      {
        kind: "INTERFACE",
        name: "InternalUrl",
        possibleTypes: [
          {
            name: "DefaultInternalUrl"
          },
          {
            name: "EntityCanonicalUrl"
          }
        ]
      },
      {
        kind: "INTERFACE",
        name: "EntityDescribable",
        possibleTypes: []
      }
    ]
  }
};

export default result;
